import UpgradePopover, {
  PopoverText
} from "@/appComponents/Blocks/Composites/UpgradePopover/UpgradePopover";
import { enumFeaturesList } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";
import { kebabCase } from "@/Utils/formatters";
import { Button } from "@theorgchartdev/storybook";
import { gUpgradeIndicatorIcon } from "@coreapp/whitelabel/brand";

const UpgradeExport = () => {
  const customTrigger = (
    <Button
      modifier="primary"
      color="brand"
      iconAlignEnd
      iconProps={{
        name: gUpgradeIndicatorIcon,
        dataTestId: `${kebabCase(enumFeaturesList.exportPDFPPT)}-upgrade-icon`
      }}
    >
      {appstr("Upgrade to export")}
    </Button>
  );

  const popoverText: PopoverText = {
    message: appstr("export upgrade message"),
    template: appstr("export upgrade template"),
    formatConfig: { bold1: { type: "bold" } },
    replaceDict: { bold1: appstr("PDF, PPT, PNG, SVG, JPEG, and XLSX formats") }
  };

  return (
    <UpgradePopover
      featureKey={enumFeaturesList.exportPDFPPT}
      customTrigger={customTrigger}
      popoverText={popoverText}
    />
  );
};

export default UpgradeExport;
